import { AxiosResponse } from 'axios';
import { HOTEL_AI_URL, INVENTORY_SERVICE_URL } from '../../../../config';
import { PaginatedSuppliers } from '../../../../interfaces/suppliers/paginatedStore.type';
import inventoryAxios from '../../../../utils/axios/inventory.axios';
import reservationAxios from '../../../../utils/axios/reservation.axios';

const tryToFetchPurchases = (
    pageNumber: number,
    pageSize: number,
    data?: any,
): Promise<AxiosResponse<PaginatedSuppliers>> => {
    const url = `${INVENTORY_SERVICE_URL}/hotel-purchase-orders/all?page=${pageNumber}&size=${pageSize}`;
    return inventoryAxios.put<PaginatedSuppliers>(url, data)
}

const tryToFetchPurchasesAndInvoices = (
    pageNumber: number,
    pageSize: number,
    data?: any,
): Promise<AxiosResponse<PaginatedSuppliers>> => {
    const url = `${INVENTORY_SERVICE_URL}/hotel-purchase-orders-invoices/all/by-hotel?page=${pageNumber}&size=${pageSize}`;
    return inventoryAxios.put<PaginatedSuppliers>(url, data)
}

const tryToCreatePurchase = (data: any): Promise<AxiosResponse> => {
    return inventoryAxios.post(`${INVENTORY_SERVICE_URL}/hotel-purchase-orders`, data);
};

const tryToEditPurchase = (id: string, data: any): Promise<AxiosResponse> => {
    return inventoryAxios.put(`${INVENTORY_SERVICE_URL}/hotel-purchase-orders/${id}/edit`, data);
};

const tryToFetchSinglePurchase = (id: string): Promise<AxiosResponse> => {
    return inventoryAxios.get(`${INVENTORY_SERVICE_URL}/hotel-purchase-orders/${id}`)
};

const tryToFetchPurchaseMismatch = (id: string): Promise<AxiosResponse> => {
    return inventoryAxios.get(`${INVENTORY_SERVICE_URL}/hotel-purchase-orders/${id}/invoice-details`)
};

const tryToDownloadPurchaseDetails = (id: string): Promise<AxiosResponse> => {
    return inventoryAxios.get(`${INVENTORY_SERVICE_URL}/hotel-purchase-orders/${id}/download`)
};

const tryToDeletePurchase = (id: string): Promise<AxiosResponse> => {
    return inventoryAxios.delete(`${INVENTORY_SERVICE_URL}/hotel-purchase-orders/${id}`);
};

const tryToUploadCashCreditFileCompare = (data: any): Promise<AxiosResponse> => {
    return reservationAxios.post(`${HOTEL_AI_URL}/cash-reconciliation/upload/credit-card-transactions`, data);
};

const tryToUploadPurchaseInvoiceFileCompare = (data: any): Promise<AxiosResponse> => {
    return inventoryAxios.put(`${INVENTORY_SERVICE_URL}/hotel-purchase-orders-invoices/match-files`, data);
};

export const PurchasesService = {
    tryToFetchPurchases,
    tryToFetchPurchasesAndInvoices,
    tryToFetchPurchaseMismatch,
    tryToCreatePurchase,
    tryToEditPurchase,
    tryToDownloadPurchaseDetails,
    tryToFetchSinglePurchase,
    tryToDeletePurchase,
    tryToUploadCashCreditFileCompare,
    tryToUploadPurchaseInvoiceFileCompare
}